<template>
  <button class="btn btn-sm btn-link text-weight-semi-bold" :disabled="disable">
    <div class="d-flex">
      <div v-if="iconLeft">
        <font-awesome-icon
          :class="textColor"
          class="mr-1"
          :icon="iconLeft"
        />
      </div>

      <div :class="labelCustomClass" class="label-btn-link text-weight-semi-bold mr-1" v-html="label">
      
      </div>
      <div class="">
        <font-awesome-icon
          v-if="icon"
          :class="textColor"
          class=""
          :icon="icon"
        />
      </div>
    </div>
  </button>
</template>
<script>
export default {
  props: {
    label: String,
    fullWidth: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      required: false,
    },
    iconLeft: {
      type: Array,
      required: false,
    },
    labelCustomClass: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textColor() {
      // let txtColor = 'text-white';
      // if (this.color == 'white') {
      //   txtColor = 'text-grey';
      // }
      // return txtColor;
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
}

.btn-sm {
  padding-left: 0px;
}

.font-size-10 {
  font-size: 10px;
}

.mt--5 {
  margin-top: -5px;
}
</style>